module.exports = __webpack_public_path__ + "img/shareBack.2e9c43b6.png";